'use strict';

var ReactDOM = require('react-dom');
var _ = require('lodash');

var getBoundingRect = function getBoundingRect(node) {
    return ReactDOM.findDOMNode(node).getBoundingClientRect();
};
var getRectByBoundingRect = function getRectByBoundingRect(boundingRect) {
    return {
        x: boundingRect.left,
        y: boundingRect.top,
        width: boundingRect.width,
        height: boundingRect.height
    };
};

var getRectByReactElement = function getRectByReactElement(elem) {
    return _(elem).thru(getBoundingRect).thru(getRectByBoundingRect).value();
};

module.exports = {
    getBoundingRect: getBoundingRect,
    getRectByBoundingRect: getRectByBoundingRect,
    getRectByReactElement: getRectByReactElement
};


// WEBPACK FOOTER //
// ./~/wix-base-ui/lib/util/rect.js